import type {
    FilterSearchConfigMap
} from "app/pages/sales-intelligence/modules/advanced-search-filtering/services/filter-search-service/types";
import advancedFilteringI18nKeys from "app/pages/sales-intelligence/modules/advanced-search-filtering/utils/i18n";

import type { AppsSearchFilterKey } from "../types/misc";

/**
 * Only filters that benefit from additional search terms are listed here.
 * Filters not in this config are still fully searchable by their translated label.
 */
export const createAppsFiltersSearchConfig = (): FilterSearchConfigMap<AppsSearchFilterKey> => ({
    market: {
        keywords: {
            translationKeys: [
                advancedFilteringI18nKeys.searchKeyword("store"),
                advancedFilteringI18nKeys.searchKeyword("market"),
                advancedFilteringI18nKeys.searchKeyword("platform"),
            ],
            literals: ["Android", "iOS", "Google Play", "App Store"],
        },
    },
    category: {
        keywords: {
            translationKeys: [advancedFilteringI18nKeys.searchKeyword("category")],
        },
    },
    iabCategories: {
        keywords: {
            translationKeys: [
                advancedFilteringI18nKeys.searchKeyword("content"),
                advancedFilteringI18nKeys.searchKeyword("taxonomy"),
            ],
            literals: ["IAB"],
        },
    },
    updateDate: {
        keywords: {
            translationKeys: [
                advancedFilteringI18nKeys.searchKeyword("release"),
                advancedFilteringI18nKeys.searchKeyword("lastUpdated"),
            ],
        },
    },
    releaseDate: {
        keywords: {
            translationKeys: [
                advancedFilteringI18nKeys.searchKeyword("release"),
                advancedFilteringI18nKeys.searchKeyword("launch"),
                advancedFilteringI18nKeys.searchKeyword("published"),
            ],
        },
    },
    sdks: {
        keywords: {
            translationKeys: [
                advancedFilteringI18nKeys.searchKeyword("library"),
                advancedFilteringI18nKeys.searchKeyword("framework"),
            ],
            literals: ["SDK"],
        },
    },
    adsSellers: {
        keywords: {
            translationKeys: [
                advancedFilteringI18nKeys.searchKeyword("monetization"),
                advancedFilteringI18nKeys.searchKeyword("advertising"),
            ],
            literals: ["ads"],
        },
    },
    permissions: {
        keywords: {
            translationKeys: [
                advancedFilteringI18nKeys.searchKeyword("access"),
                advancedFilteringI18nKeys.searchKeyword("privacy"),
            ],
        },
    },
    listedAddress: {
        keywords: {
            translationKeys: [
                advancedFilteringI18nKeys.searchKeyword("country"),
                advancedFilteringI18nKeys.searchKeyword("location"),
                advancedFilteringI18nKeys.searchKeyword("address"),
            ],
            literals: ["HQ"],
        },
    },
    downloadsAndEngagement: {
        keywords: {
            translationKeys: [
                advancedFilteringI18nKeys.searchKeyword("installs"),
                advancedFilteringI18nKeys.searchKeyword("usage"),
                advancedFilteringI18nKeys.searchKeyword("downloads"),
                advancedFilteringI18nKeys.searchKeyword("engagement"),
            ],
            literals: ["DAU", "MAU"],
        },
    },
    rating: {
        keywords: {
            translationKeys: [
                advancedFilteringI18nKeys.searchKeyword("stars"),
                advancedFilteringI18nKeys.searchKeyword("reviews"),
                advancedFilteringI18nKeys.searchKeyword("score"),
            ],
        },
    },
    appBusinessModels: {
        keywords: {
            translationKeys: [
                advancedFilteringI18nKeys.searchKeyword("freemium"),
                advancedFilteringI18nKeys.searchKeyword("subscription"),
            ],
        },
    },
    price: {
        keywords: {
            translationKeys: [
                advancedFilteringI18nKeys.searchKeyword("cost"),
                advancedFilteringI18nKeys.searchKeyword("free"),
                advancedFilteringI18nKeys.searchKeyword("paid"),
            ],
        },
    },
    identifier: {
        keywords: {
            translationKeys: [
                advancedFilteringI18nKeys.searchKeyword("package"),
                advancedFilteringI18nKeys.searchKeyword("bundle"),
                advancedFilteringI18nKeys.searchKeyword("track"),
            ],
            literals: ["ID"],
        },
    },
});
